import React from 'react';
import PropTypes from 'prop-types';
import RoundedButton from 'Components/ComponentLibrary/Components/Uncategorized/RoundedButton';
import ClientSchedulerModal from 'Components/Modals/ClientSchedulerModal';
import { addQuery } from 'Helpers/Query';
import useEventTrackingLogEvent, { categories, eventTypes } from 'EventTracking/useEventTrackingLogEvent';
import Relationship from 'facet-rest/src/domain/Relationship';

const ScheduleMeetingButton = ({
  relationship,
}) => {
  const [open, setOpen] = React.useState(false);
  const { logStandardizedEvent } = useEventTrackingLogEvent();

  const handleScheduleMeetingClick = () => {
    addQuery({ link: relationship.link('related').url() });
    logStandardizedEvent(categories.digitalOnboarding, eventTypes.clickButton, 'opening schedule meeting', { eventProperties: { description: 'schedule meeting' } });
    setOpen(true);
  };

  return (
    <>
      <RoundedButton
        onClick={handleScheduleMeetingClick}
        color={'primary'}
        variant={'contained'}
        fullWidth
        disableElevation
        test="schedule-button"
      >
        {relationship.meta('prompt')}
      </RoundedButton>
      {open && (
        <ClientSchedulerModal
          DialogProps={{
            onClose: () => {
              setOpen(false);
            },
          }}
        />
      )}
    </>
  );
};

ScheduleMeetingButton.propTypes = {
  relationship: PropTypes.instanceOf(Relationship),
};

export default ScheduleMeetingButton;
